import { COLORS } from '../colors';

export const iconColors = {
  '$icon-accent': COLORS.romeo.$07,
  '$icon-accent-dark': COLORS.romeo.$09,
  '$icon-attention': COLORS.andes.$06,
  '$icon-attention-dark': COLORS.andes.$10,
  '$icon-caution': COLORS.fuji.$06,
  '$icon-caution-dark': COLORS.fuji.$09,
  '$icon-color-placeholder': COLORS.zulu.$04,
  '$icon-dark': COLORS.zulu.$10,
  '$icon-disabled': COLORS.tango.$05,
  '$icon-disabled-dark': COLORS.tango.$07,
  '$icon-imported': COLORS.rocky.$07,
  '$icon-imported-dark': COLORS.rocky.$10,
  '$icon-neutral': COLORS.zulu.$04,
  '$icon-primary': COLORS.zulu.$08,
  '$icon-success': COLORS.everest.$06,
  '$icon-success-dark': COLORS.everest.$09,
  '$icon-unclear': COLORS.montblanc.$06,
  '$icon-unclear-dark': COLORS.montblanc.$09,
  '$icon-white': COLORS.yuma.$01,
} as const;
